
import React, { useState } from 'react'
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import ModalPtpPreguntas from 'src/pages/NewFinCompra/ModalPtpPreguntas';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { POST, guardarLead } from 'src/services';
import { Layout } from '../styleds';
import { useHistory } from 'react-router-dom';
import { urlFormaPago, urlStripePago } from 'src/services/urls';
import useMx365 from 'src/hooks/useMx365';
import franquicias from 'src/assets/img/franquicias.png'

let err = ""


const Stripe = ({ codCore }) => {
  const { idCotizacion, cotizacion } = useCotizacion();
  const history = useHistory();
  const { setLoading, resetLoading, valdiarTerminos } = usePaginaPago();
  const { addWarningToast } = useCustomToast();
  const { getUrl } = useMx365(idCotizacion, cotizacion);

const pagar = async () => {
  const Data = {
    producto: cotizacion?.producto?.nombre,
    monto: cotizacion?.valoresPagar?.total,
    moneda:  'usd',
    urlRedireccion: 'http://www.google.com'
  };

  const {data} = await POST(urlStripePago(), Data);
  if (data.estadoTransaccion) {
    console.log("Ya se pago correctamente ", data);
    const {estadoTransaccion, urlPago} = data
    window.location.href = urlPago;
  }else {
    console.log("stripe error ", data);
  }
 
}
  return (
    <div className="row justify-content-center flex-column  py-4">
      <Layout>
        <img
          onClick={valdiarTerminos(pagar)}
          className="logo"
          style={{ width: 180 }}
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/512px-Stripe_Logo%2C_revised_2016.svg.png"
          alt="PLACE TO PAY"
        />
      </Layout>
      <div className="text-center" >
        <img className="img-fluid" src={franquicias} alt="img-franquicias" style={{ maxHeight: 40 }} />
      </div>
      <ModalPtpPreguntas />
    </div>
  );
};

export default Stripe;